import api from './api';

export interface ContactFormData {
  name: string;
  email: string;
  company?: string;
  subject: string;
  message: string;
  inquiry_type?: string;
}

export interface ContactFormResponse {
  success: boolean;
  message: string;
  reference_id?: string;
}

const contactService = {
  async submitContactForm(formData: ContactFormData): Promise<ContactFormResponse> {
    const response = await api.post<ContactFormResponse>('/contact/submit', {
      name: formData.name,
      email: formData.email,
      company: formData.company,
      subject: formData.subject,
      message: formData.message,
      inquiry_type: formData.inquiry_type
    });
    
    return response.data;
  }
};

export default contactService;